import { jsxs as c, jsx as i } from "react/jsx-runtime";
import { useRef as o } from "react";
import { s as a, B as t } from "../../../base-dropdown-menu-hover-BGJV3M-p.js";
import l from "../../icons/chevron.js";
import { Card as b } from "../../containers/card/index.js";
import { useOutsideAlerter as m } from "../../../hooks/useOutsideAlerter.js";
const w = ({
  close: e = () => {
  },
  isOpen: s = !1,
  sidebarProps: n
}) => {
  const r = o(null);
  return m({
    ref: r,
    isOpen: s,
    close: e
  }), /* @__PURE__ */ c("div", { className: " b-flex b-h-full b-w-full", children: [
    /* @__PURE__ */ i(
      "div",
      {
        ref: r,
        className: `b-max-w-[310px] b-w-full ${s ? "b-overflow-y-auto md:b-overflow-y-visible" : "b-overflow-hidden"}`,
        children: /* @__PURE__ */ i(
          u,
          {
            ...n,
            className: `${n.className || ""} ${s ? a["open-sidebar"] : a["close-sidebar"]}`
          }
        )
      }
    ),
    /* @__PURE__ */ i(
      "div",
      {
        className: `md:b-hidden b-w-[calc(100vw_-_310px)] b-min-h-full b-bg-black b-z-10 ${s ? "b-opacity-25" : "b-opacity-0 b-w-0 b-hidden"}`
      }
    )
  ] });
}, u = ({
  title: e,
  action: s,
  nav: n,
  products: r,
  className: d = ""
}) => /* @__PURE__ */ c("article", { className: `${a.sidebar} ${d}`, children: [
  /* @__PURE__ */ i("h4", { className: `${a["sidebar--title"]}`, children: e }),
  /* @__PURE__ */ i("div", { className: `${a["sidebar--products"]}`, children: r }),
  /* @__PURE__ */ i("nav", { className: `${a["sidebar--nav"]}`, children: n }),
  /* @__PURE__ */ i("div", { className: `${a["sidebar--action"]}`, children: s })
] }), S = (e) => /* @__PURE__ */ i(
  "div",
  {
    ...e,
    className: `${a["sidebar--products--container"]}${e.className ? " " + e.className : ""}`
  }
), x = (e) => /* @__PURE__ */ c(
  "div",
  {
    ...e,
    className: `${a["sidebar--products--container--product"]}${e.className ? " " + e.className : ""}`,
    children: [
      /* @__PURE__ */ i(
        "h4",
        {
          className: `${a["sidebar--products--container--product--header"]} ${a["sidebar--products--container--product__underline"]} underline`,
          children: e.title
        }
      ),
      /* @__PURE__ */ i(
        "div",
        {
          className: `${a["sidebar--products--container--product--content"]}`,
          children: e.children
        }
      )
    ]
  }
), C = (e) => {
  const { optionContent: s } = e, n = { ...e };
  return delete n.optionContent, /* @__PURE__ */ i(t, { ...n, position: "right", children: /* @__PURE__ */ c("div", { className: `${a["sidebar--nav--option"]}`, children: [
    /* @__PURE__ */ i("div", { className: `${a["sidebar--nav--option--content"]}`, children: s }),
    /* @__PURE__ */ i("figure", { className: `${a["sidebar--nav--option--chevron"]}`, children: /* @__PURE__ */ i(l, {}) })
  ] }) });
}, y = ({ children: e }) => /* @__PURE__ */ i("div", { className: `${a["sidebar--nav--option--menu"]}`, children: /* @__PURE__ */ i(b, { children: e }) }), g = (e) => /* @__PURE__ */ i(
  "div",
  {
    ...e,
    className: `${a["sidebar--nav--option--menu--option"]}${e.className ? " " + e.className : ""}`
  }
);
export {
  w as SideBarWithBackdrop,
  u as Sidebar,
  y as SidebarMenuContent,
  g as SidebarMenuContentOption,
  C as SidebarNavOption,
  x as SidebarProduct,
  S as SidebarProductContainer
};
